import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../lib/utils';
import { borderGrey, darkerBG, primaryText, secondaryText, semiBoldText } from '../../../../styling/stylingHelper';
import { InventorySlideOver, slideOverCancelClass, slideOverDangerClass } from '../../../ui/InventorySlideOver';

interface RemoveAccessModalProps {
  isOpen: boolean;
  userEmail: string;
  restaurantName: string;
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveAccessModal: React.FC<RemoveAccessModalProps> = ({
  isOpen,
  userEmail,
  restaurantName,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  const labelClass = cn(secondaryText, 'text-[14px] leading-5 font-normal tracking-[-0.01rem]');
  const valueClass = cn(primaryText, semiBoldText, 'text-[16px] leading-5 truncate text-right');

  return (
    <InventorySlideOver
      isOpen={isOpen}
      onClose={onClose}
      title={t('staff.removeAccessTitle')}
      description={t('staff.removeRestaurantConfirmation')}
      closeLabel={t('common.close')}
      footer={
        <>
          <button type="button" onClick={onClose} className={slideOverCancelClass}>
            {t('staff.cancel')}
          </button>
          <button type="button" onClick={onConfirm} className={slideOverDangerClass}>
            {t('staff.removeAccessButton')}
          </button>
        </>
      }
    >
      <div className={cn('space-y-4 p-4 rounded-lg border mb-6', borderGrey, darkerBG)}>
        <div className="flex items-center justify-between gap-3">
          <span className={labelClass}>{t('staff.user')}</span>
          <span className={valueClass}>{userEmail}</span>
        </div>
        <div className="flex items-center justify-between gap-3">
          <span className={labelClass}>{t('staff.restaurantLabel')}</span>
          <span className={valueClass}>{restaurantName}</span>
        </div>
      </div>
    </InventorySlideOver>
  );
};

export default RemoveAccessModal;
